import { z } from 'zod'

/**
 * Closed seed-need capability ids from docs/ui-truth/seed-need-catalog.json (P-TEST).
 * Unknown free-form tokens fail validation — IR cannot invent provision capabilities.
 */
export const KNOWN_SEED_NEED_IDS = [
  'empty-org',
  'populated-list-min1',
  'role-matrix-six',
  'auth-otp-disposable',
  'mutation-disposable-entity',
  'auth-session-cookie',
  'readonly-walk-session',
  'solo-token-session',
] as const

export type SeedNeedId = (typeof KNOWN_SEED_NEED_IDS)[number]

export const SeedNeedIdSchema = z.enum(KNOWN_SEED_NEED_IDS)

export const SeedNeedsSchema = z.array(SeedNeedIdSchema)

export function assertKnownSeedNeeds(ids: string[]): SeedNeedId[] {
  return SeedNeedsSchema.parse(ids)
}

export function isKnownSeedNeed(id: string): id is SeedNeedId {
  return (KNOWN_SEED_NEED_IDS as readonly string[]).includes(id)
}
